<template>
  <div style="position: relative;">
    <cargo-advance-select
      ref="select"
      v-bind="selectProps"
      :default-value="params.isZero ? (value || '') : value"
      :automatic-dropdown="true"
      :data-option="params.data"
      @parentCallBack="onParentCallBack"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import TableKeyboardNav from '@/mixin/TableKeyboardNav'

export default Vue.extend({
  name: 'CargoAgGridAdvanceSelectEditor',
  components: { cargoAdvanceSelect },
  mixins: [TableKeyboardNav],
  data() {
    return {
      value: '',
      selectProps: {}
    }
  },
  created() {
    const params = this.params
    this.selectProps = params.selectProps ? { ...params.selectProps } : {}
    if (typeof params.getStaticOptions === 'function' && params.data) {
      this.selectProps.staticOptions = params.getStaticOptions(params.data)
    }
  },
  mounted() {
    const value = this.params.value
    this.value = typeof value === 'boolean' ? String(value) : value
    setTimeout(() => {
      if (this.$refs.select) {
        this.$refs.select.$refs.advanceSelectRef.focus()
        window.addEventListener('click', this.clickOther)
      }
    }, 100)
  },
  destroyed() {
    window.removeEventListener('click', this.clickOther)
  },
  methods: {
    // 处理布尔值
    getValue() {
      if (this.value === 'true') {
        return true
      }
      if (this.value === 'false') {
        return false
      }
      return this.value
    },
    onParentCallBack(item) {
      const { node, column } = this.params
      this.value = item.value
      node.setDataValue(column.colId, item.value)
    },
    clickOther(e) {
      if (!this.$el.contains(e.target)) {
        const { api } = this.params
        api.stopEditing()
      }
    }
  }
})
</script>

<style>
</style>
